module.exports = __webpack_public_path__ + "img/45.663a61e0.jpg";